"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var tooltip_1 = __importDefault(require("@components/tooltip"));
var style_1 = require("./style");
var stopPropagation = function (e) { e.stopPropagation(); };
var Award = function (_a) {
    var Icon = _a.icon, linkProps = _a.linkProps, tooltip = _a.tooltip, type = _a.type;
    var hasTooltip = tooltip !== undefined;
    var isLink = type === 'link';
    if (!hasTooltip) {
        return (react_1.default.createElement(style_1.Wrapper, { as: isLink ? 'a' : 'div', hasTooltip: hasTooltip, href: isLink ? linkProps === null || linkProps === void 0 ? void 0 : linkProps.href : undefined, isLink: isLink, onClick: isLink ? stopPropagation : undefined, target: isLink ? linkProps === null || linkProps === void 0 ? void 0 : linkProps.target : undefined },
            react_1.default.createElement(Icon, { className: 'Link__icon' })));
    }
    return (react_1.default.createElement(style_1.Wrapper, { as: isLink ? 'a' : 'div', hasTooltip: hasTooltip, href: isLink ? linkProps === null || linkProps === void 0 ? void 0 : linkProps.href : undefined, isLink: isLink, onClick: isLink ? stopPropagation : undefined, target: isLink ? linkProps === null || linkProps === void 0 ? void 0 : linkProps.target : undefined },
        react_1.default.createElement(tooltip_1.default, { withPortal: true, content: (react_1.default.createElement(react_1.Fragment, null,
                tooltip.text,
                tooltip.subText !== undefined ? (react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement("br", null),
                    tooltip.subText)) : null)), placement: 'top', variant: 'secondary', wrapperClassName: 'Link__tooltipWrapper' },
            react_1.default.createElement(Icon, { className: 'Link__icon' }))));
};
Award.displayName = 'Award';
exports.default = Award;
